import { fromJS, Map } from 'immutable';
import Actions from 'flow/actions';
import { isFavoriteType } from 'flow/utils/favorite-utils';

import { listToMap } from 'flow/utils';

const initialState = Map();

const formatFavoriteMap = (favoritesMap) => {
    return favoritesMap.map(formatFavoriteData);
};

export const formatFavoriteData = (favorite) => {
    return favorite.mapKeys((key) =>
        isFavoriteType(key) ? 'favoriteData' : key,
    );
};

export const favoritesReducer = (state = initialState, action) => {
    switch (action ? action.type : null) {
        case Actions.CLEAR_STATE: {
            return initialState;
        }
        case Actions.RESULT_FAVORITES: {
            const favoritesList = fromJS(action.data);
            const favoritesMap = listToMap(favoritesList, (f) => f.get('key'));
            return formatFavoriteMap(favoritesMap);
        }
        case Actions.RESULT_FAVORITE: {
            const favorite = fromJS(action.data);
            return state.set(action.data.key, formatFavoriteData(favorite));
        }
        case Actions.REMOVED_FAVORITE: {
            return state.delete(action.key);
        }
        default: {
            return state;
        }
    }
};

export default favoritesReducer;
